import { render, staticRenderFns } from "./materialSearch.vue?vue&type=template&id=47335fd6"
import script from "./materialSearch.vue?vue&type=script&lang=js"
export * from "./materialSearch.vue?vue&type=script&lang=js"
import style0 from "./materialSearch.vue?vue&type=style&index=0&id=47335fd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports